import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        lastButton: {
            width: 100,
            paddingLeft: 10,
        },
        doubleButtons: {
            display: 'inline-flex',
        },
    }
})

export default useStyles
